import React from 'react';
import styles from './CoreColumns.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreColumns({ attributes, innerBlocks }) {
  const styles = formatStyles(attributes.style);
  const className = attributes.className?.split(' ') || [];

  return (
    <div id={attributes.anchor} className={cx(['ns_columns', 'columns', attributes.textColor && `text-color-${attributes.textColor}`, ...className, attributes.isStackedOnMobile && 'collapseMobile', attributes.verticalAlignment && `alignItems-${attributes.verticalAlignment}`, innerBlocks && `col-count-${innerBlocks.length}`])} style={styles}>
      {React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}
    </div>
  )
}


CoreColumns.fragments = {
  key: `CoreColumnsFragment`,
  entry: gql `
  fragment CoreColumnsFragment on CoreColumns {
    attributes {
      anchor
      className
      verticalAlignment
      isStackedOnMobile
      style
      textColor
    }
  }
`,
};


CoreColumns.config = {
	name: 'CoreColumns',
};
CoreColumns.displayName = 'CoreColumns';